import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(
    private readonly translateService: TranslateService,
    private readonly datePipe: DatePipe
  ) {}

  /**
   * @see https://docs.angularjs.org/api/ng/filter/date
   */
  public transform(value: Date | string, pattern = 'mediumDate'): string {
    return this.datePipe.transform(
      value,
      pattern,
      null,
      this.translateService.currentLang
    );
  }
}
